import configHelper from '@/config/ConfigHelper'

const ALLOWED_MODE_IDS_CONSTANT = { 
  ISSUING_CREATION: 1,
  SOCIETY_CREATION: 2,
  COMPANY_CREATION: 3,
  CERTIFICATE_CREATION: 4,
  PRODUCT_CREATION: 5
}
function GenerateAllowedModeIds () {
  return ALLOWED_MODE_IDS_CONSTANT
}
function GenerateAllowedModes () {
  return {
    [ALLOWED_MODE_IDS_CONSTANT.ISSUING_CREATION]: {
      mode: 'ISSUING_CREATION',
      exclusive: false,
      routes: [
        'invoicesissuing',
        'masters/society/details',
        'masters/society/locations/details',
        'masters/society/locations/administrativecenters',
        'masters/society/locations/administrativecenters/details',
        'masters/impuestos/details',
        'masters/products/details'
      ],
      transitionAllowedParam: 'issuingCreation',
      getTransitionAllowed: 'invoicesIssuing/isEntityCreation',
      setTransitionAllowed: 'invoicesIssuing/setEntityCreation'
    },
    [ALLOWED_MODE_IDS_CONSTANT.SOCIETY_CREATION]: {
      mode: 'SOCIETY_CREATION',
      exclusive: false,
      routes: [
        'masters/society/details',
        'masters/society/locations/details',
        'masters/society/locations/administrativecenters',
        'masters/society/locations/administrativecenters/details'
      ],
      transitionAllowedParam: 'societyCreation',
      getTransitionAllowed: 'app/isSocietyCreation',
      setTransitionAllowed: 'app/setSocietyCreation'
    },
    [ALLOWED_MODE_IDS_CONSTANT.COMPANY_CREATION]: {
      mode: 'COMPANY_CREATION',
      exclusive: false,
      routes: [
        'companies/details',
        'companies/config',
        'companies/reportconfig',
        'companies/pgeconfig',
        'companies/apsconfig'
      ],
      transitionAllowedParam: 'companiesCreation',
      getTransitionAllowed: 'app/isCompanyCreation',
      setTransitionAllowed: 'app/setCompanyCreation'
    },
    [ALLOWED_MODE_IDS_CONSTANT.CERTIFICATE_CREATION]: {
      mode: 'CERTIFICATE_CREATION',
      exclusive: false,
      routes: [
        'certificates/detail',
        'certificates/companies'
      ],
      transitionAllowedParam: 'certificateCreation',
      getTransitionAllowed: 'app/isCertificateCreation',
      setTransitionAllowed: 'app/setCertificateCreation'
    },
    [ALLOWED_MODE_IDS_CONSTANT.PRODUCT_CREATION]: {
      mode: 'PRODUCT_CREATION',
      exclusive: false,
      routes: [
        'product/detail',
      ],
      transitionAllowedParam: 'productCreation',
      getTransitionAllowed: 'app/isProductCreation',
      setTransitionAllowed: 'app/setProductCreation'
    }
  }
}

function ALLOWED_MODES (state) {
  return configHelper.getConfig(state, 'ALLOWED_MODES', GenerateAllowedModes, false)
}
function ALLOWED_MODE_IDS (state) {
  return configHelper.getConfig(state, 'ALLOWED_MODE_IDS', GenerateAllowedModeIds, false)
}

export { ALLOWED_MODES, ALLOWED_MODE_IDS }
